﻿import * as Models from "../../models/models";
import * as LogService from "../../core/services/logservice/log.service";
import {ScreenLockService} from "../../core/services/screenLockService/screenLock.service";
import {IAdminPaymentReceiptParams} from './adminPaymentReceiptParams';
import {AdminPaymentReceiptViewModel} from './adminPaymentReceipt.viewmodel';


export class AdminPaymentReceiptController {
    static $inject = ['$state', 'logService', 'screenLockService','$stateParams'];

    private adminPaymentReceiptViewModel: AdminPaymentReceiptViewModel;

    constructor(
        
        private $state: ng.ui.IStateService,
        private logger: LogService.ILogService,
        private screenLockService: ScreenLockService,
        private $stateParams: any    ) {

        this.adminPaymentReceiptViewModel = new AdminPaymentReceiptViewModel();

        this.activate();
    }

    private activate() {

        this.adminPaymentReceiptViewModel.decisionType = this.$stateParams.decisionType;
        this.adminPaymentReceiptViewModel.reasonCode = this.$stateParams.reasonCode;
        this.adminPaymentReceiptViewModel.merchantReferenceCode = this.$stateParams.merchantReferenceCode;
        this.adminPaymentReceiptViewModel.requestId = this.$stateParams.requestId;
        this.screenLockService.broadcast(0);
    }

    public goToPaymentMethodSearch(): void {

        this.$state.go('shellFrame.administrationFrame.paymentMethodSearch');
    }
}